import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AWS_CONFIG } from './environment'
import store from './store'
import Vuelidate from 'vuelidate'
import { bytes, datetime } from './filter'
import titleMixin from './title'
import('./assets/loading.css')
import('./style.css')

// AWS Amplify関連の設定
Amplify.configure(AWS_CONFIG)

// Semantic UIの読み込み
import('semantic-ui-css/semantic.min.css')

// import flatpickr
import('flatpickr/dist/flatpickr.min.css')
import('flatpickr/dist/plugins/monthSelect/style.css')

Vue.use(AmplifyModules)
Vue.use(Vuelidate)
Vue.mixin(titleMixin)

Vue.config.productionTip = false

Vue.filter('bytes', bytes)
Vue.filter('datetime', datetime)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
